<template>
    <div class="flight-info-component">
      <div class="flight">
        <p class="text-lg lg:text-xl font-black text-black mb-2">
          {{ departureTime.format("LT") }}
        </p>
        <p class="text-base text-black">
          {{ origin }}
        </p>
      </div>
      <div class="duration color-brown-grey flex-grow">
        <p class="paragraph-h-16">
          {{ duration }}
        </p>
        <hr class="mx-auto" />
        <p class="paragraph-h-16">{{ $tc('shared.stopOvers', 0) }}</p>
      </div>
      <div class="flight pr-5 w-fit">
        <div class="flex relative ">
          <p class="text-lg lg:text-xl font-black text-black mb-2">
            {{ moment(arrivalTime).format("LT") }}
          </p>
          <sup v-if="isNextDay"  class="absolute right-[-5px] sm:right-[-10px] lg:right-[5px] top-[-3px] text-xs lg:text-[12px]">+1</sup>
        </div>
        <p class="text-base text-black">
          {{ destination }}
        </p>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import { locationHasTimezoneDiff } from '../../pages/nights/helpers';

export default {
  props: {
    origin: {
      type: String,
      required: true,
    },
    destination: {
      type: String,
      required: true,
    },
    departureTime: {
      type: Object,
      required: true,
    },
    arrivalTime: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moment,
    }
  },

  computed: {
    timezoneDiff() {
      if (locationHasTimezoneDiff(this.destination)) {
        return +1;
      }
      if (locationHasTimezoneDiff(this.origin)) {
        return -1;
      }
      return 0;
    },
    duration() {
      const departure = moment(this.departureTime);
      const arrival = moment(this.arrivalTime).add(this.timezoneDiff, 'hours');
      const hours = arrival.diff(departure, "hours");
      departure.add(hours, "hours");
      const minutes = arrival.diff(departure, "minutes");
      const hoursText = hours ? `${hours}h` : "";
      const minutesText = minutes ? `${minutes}m` : "";
      if (hours && minutes) {
        return `${hoursText}, ${minutesText}`;
      }
      return hours ? hoursText : minutesText;
    },
    isNextDay() {
      const departure = moment(this.departureTime);
      const arrival = moment(this.arrivalTime).add(this.timezoneDiff, 'hours');
      const departureDay = departure.dayOfYear();
      const arrivalDay = arrival.dayOfYear();
      return arrivalDay > departureDay;
    }
  }
}
</script>

<style scoped lang="scss">
.flight-info-component {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: 1fr 1.5fr 1fr;

  @media (min-width: 640px) {
    grid-template-columns: 5rem 1fr 5rem;
  }
  @media (min-width: 1024px) {
    grid-template-columns: 7.5rem 1fr 7.5rem;
  }

  > div {
    overflow: hidden;
  }

  p {
    overflow-wrap: break-word;
    text-align: center;
    line-height: 1.25;
  }

  .flight {
    display: flex;
    flex-direction: column;
    align-self: stretch;

    p {
      flex-grow: 1;
    }
  }

  .duration {
    align-self: center;
  }
}
</style>
